import { useFormContext } from 'react-hook-form';
export interface SelectFieldOption {
  value: any;
  label: string;
  isDefault?: boolean;
}
interface SelectFieldProps {
  name: string;
}

export const FormError = ({ name }: SelectFieldProps): any => {
  const {
    formState: { errors },
  } = useFormContext();

  function getErrorMessage(error: any, propertyPath: string) {
    const pathArray = propertyPath.split('.');
    let currentError = error;
    for (const path of pathArray) {
      currentError = currentError && currentError[path];
      if (!currentError) {
        return null;
      }
    }
    return currentError.message || null;
  }

  return <>{getErrorMessage(errors, name) && <label className="errorMsg">{getErrorMessage(errors, name)}</label>}</>;
};
